export const TOUR_SHOWING_APPLICATION_SOURCE_PAGE_BOOOKMARKED = 'FROM_BOOKMARKED_PAGE';
export const TOUR_SHOWING_APPLICATION_SOURCE_PAGE_LISTING = 'FROM_LISTING_PAGE';
export const TOUR_SHOWING_APPLICATION_SOURCE_PAGE_LISTING_PHOTOS = 'FROM_LISTING_PHOTO_GALLERY_PAGE';
export const TOUR_SHOWING_APPLICATION_SOURCE_RECOMMENDED_LISTING = 'RECOMMENDED_FROM_LISTING_PAGE';
export const TOUR_SHOWING_APPLICATION_SOURCE_RECOMMENDED_PAGE_TOURS = 'RECOMMENDED_FROM_TOURS_PAGE';
export const TOUR_SHOWING_APPLICATION_SOURCE_PAGE_LISTING_SUNLOCK = 'FROM_LISTING_PAGE_SUNLOCK_SECTION';
export const TOUR_SHOWING_APPLICATION_SOURCE_PAGE_APARTMENT_PAGE = 'TOUR_SHOWING_APPLICATION_SOURCE_PAGE_APARTMENT_PAGE'; // eslint-disable-line max-len

export const TOUR_STATUS_REQUESTED = 'requested';
export const TOUR_STATUS_SCHEDULED = 'scheduled';
export const TOUR_STATUS_COMPLETED = 'completed';
export const TOUR_STATUS_CANCELLED = 'cancelled';

export const TOUR_TYPE_RENTER_REQUESTED = 'renterRequested'; // Renter
export const TOUR_TYPE_RENTER_SCHEDULED = 'renterScheduled'; // Renter - Home Vacant
export const TOUR_TYPE_SELF_SHOWING = 'selfShowing'; // Sunlock
export const TOUR_TYPE_ADMIN_CREATED = 'adminCreated'; // Admin Tool
export const TOUR_TYPE_LOCATOR_GUEST_CARD = 'locatorGuestCard'; // Locator guest card flow

export const TOUR_TYPE_LIST = [
  TOUR_TYPE_RENTER_REQUESTED,
  TOUR_TYPE_RENTER_SCHEDULED,
  TOUR_TYPE_SELF_SHOWING,
  TOUR_TYPE_ADMIN_CREATED,
  TOUR_TYPE_LOCATOR_GUEST_CARD,
];

export const TOUR_STATUS_LIST_GROUP_ACTIVE = [
  TOUR_STATUS_REQUESTED,
  TOUR_STATUS_SCHEDULED,
];

// TODO: Remove after running deprecation script.
export const TOUR_STATUS_PENDING = 'pending';
export const TOUR_STATUS_PENDING_CONFIRMATION = 'pendingConfirmation';

export const TOUR_STATUS_AVAILABLE_TRANSITIONS = {
  [TOUR_STATUS_REQUESTED]: [
    TOUR_STATUS_SCHEDULED,
    TOUR_STATUS_CANCELLED,
  ],
  [TOUR_STATUS_SCHEDULED]: [
    TOUR_STATUS_REQUESTED,
    TOUR_STATUS_COMPLETED,
    TOUR_STATUS_CANCELLED,
  ],
  [TOUR_STATUS_COMPLETED]: [],
};

export const TOUR_STATUS_LIST = Object.keys(TOUR_STATUS_AVAILABLE_TRANSITIONS);

export const TOUR_STATUS_OPTION_ITEMS = [
  {
    label: 'Requested',
    value: TOUR_STATUS_REQUESTED,
  },
  {
    label: 'Scheduled',
    value: TOUR_STATUS_SCHEDULED,
  },
  {
    label: 'Completed',
    value: TOUR_STATUS_COMPLETED,
  },
];

export const TOUR_REQUEST_SHOWING_FIELDS = [
  'requestedFrom',
  'listingId',
  'createNewTour',
  'addToTourId',
  'date',
  'times',
];

export const TOUR_SHOWING_STATUS_UNREAD = 'unread';
export const TOUR_SHOWING_STATUS_PENDING = 'pending';
export const TOUR_SHOWING_STATUS_CONFIRMED = 'confirmed';
export const TOUR_SHOWING_STATUS_COMPLETED = 'completed';
export const TOUR_SHOWING_STATUS_FAILED = 'failed';
export const TOUR_SHOWING_STATUS_WAITLIST = 'waitlist';

// Tour cancel reasons.
export const TOUR_CANCEL_REASON_NO_RESPONSE = 'noResponse';
export const TOUR_CANCEL_REASON_INVALID_NUMBER = 'invalidNumber';
export const TOUR_CANCEL_REASON_WRONG_NUMBER = 'wrongNumber';
export const TOUR_CANCEL_REASON_MOVE_IN_FAR = 'moveInFar';
export const TOUR_CANCEL_REASON_RENEWED_LEASE = 'renewedLease';
export const TOUR_CANCEL_REASON_MOVED_ON_THEIR_OWN = 'movedOnTheirOwn';
export const TOUR_CANCEL_REASON_CHOSE_PREVIOUSLY_TOURED_HOME = 'chosePreviouslyTouredHome';
export const TOUR_CANCEL_REASON_DOESNT_WANT_OUR_SERVICE = 'doesntWantOurService';
export const TOUR_CANCEL_REASON_ACCIDENTALLY_REQUESTED = 'accidentallyRequested';
export const TOUR_CANCEL_REASON_RESCHEDULED = 'rescheduled';
export const TOUR_CANCEL_REASON_SAVED_FOR_LATER = 'savedForLater';
export const TOUR_CANCEL_REASON_REMOVED_LAST_SHOWING = 'removedLastShowing';
export const TOUR_CANCEL_REASON_NO_TOUR_GUIDE_AVAILABLE = 'noTourGuideAvailable';
export const TOUR_CANCEL_REASON_STARTED_USING_OTHER_AGENT = 'startedUsingOtherAgent';
export const TOUR_CANCEL_REASON_ALL_SHOWINGS_FAILED = 'allShowingsFailed';
export const TOUR_CANCEL_REASON_NO_REASON_GIVEN = 'noReasonGiven';
export const TOUR_CANCEL_REASON_NO_SHOW = 'noShow';
export const TOUR_CANCEL_REASON_TOUR_CART_AB_TEST = 'tourCartAbTest';
export const TOUR_CANCEL_REASON_ASSIGNED_TO_APARTMENT_LOCATOR = 'assignedTourToApartmentLocator';
export const TOUR_CANCEL_REASON_OTHER = 'other';

// User-exposed tour cancel reasons. These cancel reasons should only be used for user-originated tour cancellations.
export const TOUR_CANCEL_REASON_USER_JUST_CURIOUS = 'user-justCurious';
export const TOUR_CANCEL_REASON_USER_RESCHEDULE_TIME_UNKNOWN = 'user-rescheduleTimeUnknown';
export const TOUR_CANCEL_REASON_USER_NOT_INTERESTED = 'user-notInterested';
export const TOUR_CANCEL_REASON_USER_NOT_LIKE_NEIGHBORHOOD = 'user-notLikeNeighborhood';
export const TOUR_CANCEL_REASON_USER_PROVIDED = 'user-userProvided';

export const TOUR_CANCEL_REASON_USER_RELATED_OPTION_ITEMS = [
  {
    label: 'I was just curious how Sunroom works',
    value: TOUR_CANCEL_REASON_USER_JUST_CURIOUS,
  },
  {
    label: 'I want to reschedule but don\'t know what time yet',
    value: TOUR_CANCEL_REASON_USER_RESCHEDULE_TIME_UNKNOWN,
  },
  {
    label: 'Not interested in the homes',
    value: TOUR_CANCEL_REASON_USER_NOT_INTERESTED,
  },
  {
    label: 'Don\'t like the neighborhood',
    value: TOUR_CANCEL_REASON_USER_NOT_LIKE_NEIGHBORHOOD,
  },
];

export const TOUR_CANCEL_REASON_TOUR_RELATED_OPTION_ITEMS = [
  {
    label: 'Accidentally requested',
    value: TOUR_CANCEL_REASON_ACCIDENTALLY_REQUESTED,
  },
  {
    label: 'Assigned to Apartment Locator',
    value: TOUR_CANCEL_REASON_ASSIGNED_TO_APARTMENT_LOCATOR,
  },
  {
    label: 'All showings failed',
    value: TOUR_CANCEL_REASON_ALL_SHOWINGS_FAILED,
  },
  {
    label: 'Cancelled, no reason given',
    value: TOUR_CANCEL_REASON_NO_REASON_GIVEN,
  },
  {
    label: 'Move in date too far',
    value: TOUR_CANCEL_REASON_MOVE_IN_FAR,
  },
  {
    label: 'No show',
    value: TOUR_CANCEL_REASON_NO_SHOW,
  },
  {
    label: 'No tour guide available',
    value: TOUR_CANCEL_REASON_NO_TOUR_GUIDE_AVAILABLE,
  },
  {
    label: 'Tour Cart A/B Test',
    value: TOUR_CANCEL_REASON_TOUR_CART_AB_TEST,
  },
  {
    label: 'Other',
    value: TOUR_CANCEL_REASON_OTHER,
  },
];

export const TOUR_CANCEL_REASON_CUSTOMER_RELATED_OPTION_ITEMS = [
  {
    label: 'Chose previously toured home',
    value: TOUR_CANCEL_REASON_CHOSE_PREVIOUSLY_TOURED_HOME,
  },
  {
    label: 'Doesn\'t need/want our service',
    value: TOUR_CANCEL_REASON_DOESNT_WANT_OUR_SERVICE,
  },
  {
    label: 'Invalid number',
    value: TOUR_CANCEL_REASON_INVALID_NUMBER,
  },
  {
    label: 'Moved on their own',
    value: TOUR_CANCEL_REASON_MOVED_ON_THEIR_OWN,
  },
  {
    label: 'No response',
    value: TOUR_CANCEL_REASON_NO_RESPONSE,
  },
  {
    label: 'Renewed lease',
    value: TOUR_CANCEL_REASON_RENEWED_LEASE,
  },
  {
    label: 'Started using other agent',
    value: TOUR_CANCEL_REASON_STARTED_USING_OTHER_AGENT,
  },
  {
    label: 'Wrong number',
    value: TOUR_CANCEL_REASON_WRONG_NUMBER,
  },
  {
    label: 'Other',
    value: TOUR_CANCEL_REASON_OTHER,
  },
];

export const TOUR_SHOWING_FAILURE_REASON_LISTING_FEATURES_DONT_FIT = 'listingFeaturesDontFit';
export const TOUR_SHOWING_FAILURE_REASON_REMOVED_FROM_TOUR_THROUGH_APP = 'removedFromTourThroughApp';
export const TOUR_SHOWING_FAILURE_REASON_APARTMENT_UNIT_NOT_AVAILABLE_TO_SHOW = 'apartmentUnitNotAvailableToShow'; // eslint-disable-line max-len
export const TOUR_SHOWING_FAILURE_REASON_APARTMENT_UNIT_NOT_AVAILABLE_FOR_LEASE = 'apartmentUnitNotAvailableForLease'; // eslint-disable-line max-len
export const TOUR_SHOWING_FAILURE_REASON_APARTMENT_OFFICE_CLOSED = 'apartmentOfficeClosed';
export const TOUR_SHOWING_FAILURE_REASON_CHANGED_MIND_ON_NEIGHBORHOOD = 'changedMindOnNeighborhood';
export const TOUR_SHOWING_FAILURE_REASON_TOO_FAR_AWAY_FROM_REST_OF_SHOWINGS = 'tooFarAwayFromRestOfShowings';
export const TOUR_SHOWING_FAILURE_REASON_TENANT_PREVENTED_SHOWING = 'tenantPreventedShowing';
export const TOUR_SHOWING_FAILURE_REASON_NOT_ENOUGH_TIME_FOR_REST_OF_SHOWINGS = 'notEnoughTimeForRestOfShowings'; // eslint-disable-line max-len
export const TOUR_SHOWING_FAILURE_REASON_HOME_ALREADY_ACCEPTED_APP_OR_LEASED = 'homeAlreadyAcceptedAppOrLeased'; // eslint-disable-line max-len
export const TOUR_SHOWING_FAILURE_REASON_OUTSIDE_OF_TOUR_RANGE = 'outsideOfTourRange';
export const TOUR_SHOWING_FAILURE_REASON_COULDNT_GET_PERMISSION_FROM_OWNER = 'couldntGetPermissionFromOwner';
export const TOUR_SHOWING_FAILURE_REASON_COULDNT_GET_INTO_LOCKBOX = 'couldntGetIntoLockbox';
export const TOUR_SHOWING_FAILURE_REASON_COULDNT_FIND_KEY = 'couldntFindKey';
export const TOUR_SHOWING_FAILURE_REASON_ENDED_TOUR_EARLY = 'endedTourEarly';
export const TOUR_SHOWING_FAILURE_REASON_FAILED_BY_TOUR_GUIDE = 'failedByTourGuide';
export const TOUR_SHOWING_FAILURE_REASON_ASSIGNED_TO_APARTMENT_LOCATOR = 'assignedToApartmentLocator';
export const TOUR_SHOWING_FAILURE_REASON_OTHER = 'other';
export const TOUR_SHOWING_FAILURE_REASON_TOUR_GUIDE_PROVIDED = 'tourGuideProvided';
export const TOUR_SHOWING_FAILURE_REASON_NO_SHOWING = 'noContactAndNoShowing';
export const TOUR_SHOWING_FAILURE_REASON_STOPPED_TOUR_SHORT_OR_SKIPPED_SHOWING = 'stoppedTourShortOrSkippedShowing'; // eslint-disable-line max-len
export const TOUR_SHOWING_FAILURE_REASON_WANTS_TO_RESCHEDULE = 'wantsToReschedule';
export const TOUR_SHOWING_FAILURE_REASON_CANCELLED_NO_REASON = 'cancelledNoReason';
export const TOUR_SHOWING_FAILURE_REASON_DOESNT_WANT_OUR_SERVICE = 'doesntWantOurService';
export const TOUR_SHOWING_FAILURE_REASON_UNLOCK_SUNLOCK_FAILURE = 'unlockSunlockFailure';
export const TOUR_SHOWING_FAILURE_REASON_GEOLOCATION_ERROR = 'geolocationError';

export const TOUR_SHOWING_FAILURE_REASON_MAPPING = {
  [TOUR_SHOWING_FAILURE_REASON_ASSIGNED_TO_APARTMENT_LOCATOR]: 'Assigned to Apartment Locator',
  [TOUR_SHOWING_FAILURE_REASON_CHANGED_MIND_ON_NEIGHBORHOOD]: 'Changed Mind on Neighborhood',
  [TOUR_SHOWING_FAILURE_REASON_LISTING_FEATURES_DONT_FIT]: 'Listing Features Don\'t Fit',
  [TOUR_SHOWING_FAILURE_REASON_COULDNT_GET_PERMISSION_FROM_OWNER]: 'MLS: Couldn\'t Get Permission from Owner',
  [TOUR_SHOWING_FAILURE_REASON_COULDNT_GET_INTO_LOCKBOX]: 'MLS: Couldn\'t Get into Lockbox',
  [TOUR_SHOWING_FAILURE_REASON_COULDNT_FIND_KEY]: 'MLS: Couldn\'t Find Key',
  [TOUR_SHOWING_FAILURE_REASON_HOME_ALREADY_ACCEPTED_APP_OR_LEASED]:
  'MLS: Home already accepting App or Leased',
  [TOUR_SHOWING_FAILURE_REASON_TENANT_PREVENTED_SHOWING]: 'MLS: Tenant Prevented Showing',
  [TOUR_SHOWING_FAILURE_REASON_NOT_ENOUGH_TIME_FOR_REST_OF_SHOWINGS]:
  'Not Enough time to see the rest of the showings',
  [TOUR_SHOWING_FAILURE_REASON_OUTSIDE_OF_TOUR_RANGE]: 'Outside of our Tour Range',

  [TOUR_SHOWING_FAILURE_REASON_REMOVED_FROM_TOUR_THROUGH_APP]: 'Removed from Showing List through app',

  [TOUR_SHOWING_FAILURE_REASON_APARTMENT_OFFICE_CLOSED]: 'SAD: Apartment Office Closed',
  [TOUR_SHOWING_FAILURE_REASON_APARTMENT_UNIT_NOT_AVAILABLE_TO_SHOW]:
  'SAD: Apartment Unit Not Available to Show',
  [TOUR_SHOWING_FAILURE_REASON_APARTMENT_UNIT_NOT_AVAILABLE_FOR_LEASE]:
  'SAD: Apartment Unit not Available for Lease',
  [TOUR_SHOWING_FAILURE_REASON_TOO_FAR_AWAY_FROM_REST_OF_SHOWINGS]:
  'Too Far away from the rest of the showings in the Tour',
  [TOUR_SHOWING_FAILURE_REASON_ENDED_TOUR_EARLY]: 'Wants to pursue earlier showing & ended tour early',
  [TOUR_SHOWING_FAILURE_REASON_UNLOCK_SUNLOCK_FAILURE]: 'Unlock Sunlock failure',
  [TOUR_SHOWING_FAILURE_REASON_GEOLOCATION_ERROR]: 'Geolocation Error',
};

export const TOUR_SHOWING_FAILURE_REASON_OPTION_ITEMS = [
  {
    label: 'Assigned to Apartment Locator',
    value: TOUR_SHOWING_FAILURE_REASON_ASSIGNED_TO_APARTMENT_LOCATOR,
  },
  {
    label: 'Changed Mind on Neighborhood',
    value: TOUR_SHOWING_FAILURE_REASON_CHANGED_MIND_ON_NEIGHBORHOOD,
  },
  {
    label: 'Listing Features Don\'t Fit',
    value: TOUR_SHOWING_FAILURE_REASON_LISTING_FEATURES_DONT_FIT,
  },
  {
    label: 'MLS: Couldn\'t Get Permission from Owner',
    value: TOUR_SHOWING_FAILURE_REASON_COULDNT_GET_PERMISSION_FROM_OWNER,
  },
  {
    label: 'MLS: Couldn\'t Get into Lockbox',
    value: TOUR_SHOWING_FAILURE_REASON_COULDNT_GET_INTO_LOCKBOX,
  },
  {
    label: 'MLS: Couldn\'t Find Key',
    value: TOUR_SHOWING_FAILURE_REASON_COULDNT_FIND_KEY,
  },
  {
    label: 'MLS: Home already accepting App or Leased',
    value: TOUR_SHOWING_FAILURE_REASON_HOME_ALREADY_ACCEPTED_APP_OR_LEASED,
  },
  {
    label: 'MLS: Tenant Prevented Showing',
    value: TOUR_SHOWING_FAILURE_REASON_TENANT_PREVENTED_SHOWING,
  },
  {
    label: 'Not Enough time to see the rest of the showings',
    value: TOUR_SHOWING_FAILURE_REASON_NOT_ENOUGH_TIME_FOR_REST_OF_SHOWINGS,
  },
  {
    label: 'Outside of our Tour Range',
    value: TOUR_SHOWING_FAILURE_REASON_OUTSIDE_OF_TOUR_RANGE,
  },
  {
    label: 'Removed from Showing List through app',
    value: TOUR_SHOWING_FAILURE_REASON_REMOVED_FROM_TOUR_THROUGH_APP,
  },
  {
    label: 'SAD: Apartment Office Closed',
    value: TOUR_SHOWING_FAILURE_REASON_APARTMENT_OFFICE_CLOSED,
  },
  {
    label: 'SAD: Apartment Unit Not Available to Show',
    value: TOUR_SHOWING_FAILURE_REASON_APARTMENT_UNIT_NOT_AVAILABLE_TO_SHOW,
  },
  {
    label: 'SAD: Apartment Unit not Available for Lease',
    value: TOUR_SHOWING_FAILURE_REASON_APARTMENT_UNIT_NOT_AVAILABLE_FOR_LEASE,
  },
  {
    label: 'Too Far away from the rest of the showings in the Tour',
    value: TOUR_SHOWING_FAILURE_REASON_TOO_FAR_AWAY_FROM_REST_OF_SHOWINGS,
  },
  {
    label: 'Wants to pursue earlier showing & ended tour early',
    value: TOUR_SHOWING_FAILURE_REASON_ENDED_TOUR_EARLY,
  },
];

export const TOUR_AGENT_SHOWING_FAILURE_REASON_OPTION_ITEMS = [
  {
    label: 'No show & no contact',
    value: TOUR_SHOWING_FAILURE_REASON_NO_SHOWING,
  },
  {
    label: 'Stopped tour short or skipped showing',
    value: TOUR_SHOWING_FAILURE_REASON_STOPPED_TOUR_SHORT_OR_SKIPPED_SHOWING,
  },
  {
    label: 'Wants to reschedule',
    value: TOUR_SHOWING_FAILURE_REASON_WANTS_TO_RESCHEDULE,
  },
  {
    label: 'Cancelled, no reason given',
    value: TOUR_SHOWING_FAILURE_REASON_CANCELLED_NO_REASON,
  },
  {
    label: 'Changed mind on neighborhood',
    value: TOUR_SHOWING_FAILURE_REASON_CHANGED_MIND_ON_NEIGHBORHOOD,
  },
  {
    label: 'Listing features don\'t fit',
    value: TOUR_SHOWING_FAILURE_REASON_LISTING_FEATURES_DONT_FIT,
  },
  {
    label: 'Doesn\'t need/want our service',
    value: TOUR_SHOWING_FAILURE_REASON_DOESNT_WANT_OUR_SERVICE,
  },
  {
    label: 'Couldn\'t get into lockbox',
    value: TOUR_SHOWING_FAILURE_REASON_COULDNT_GET_INTO_LOCKBOX,
  },
  {
    label: 'Couldn\'t find key',
    value: TOUR_SHOWING_FAILURE_REASON_COULDNT_FIND_KEY,
  },
  {
    label: 'Current tenant prevented showing',
    value: TOUR_SHOWING_FAILURE_REASON_TENANT_PREVENTED_SHOWING,
  },
  {
    label: 'Home already accepting app or leased',
    value: TOUR_SHOWING_FAILURE_REASON_HOME_ALREADY_ACCEPTED_APP_OR_LEASED,
  },
];

export const TOUR_AND_SHOWING_CANCEL_REASON_ALL = [
  ...TOUR_CANCEL_REASON_USER_RELATED_OPTION_ITEMS,
  ...TOUR_CANCEL_REASON_TOUR_RELATED_OPTION_ITEMS,
  ...TOUR_CANCEL_REASON_CUSTOMER_RELATED_OPTION_ITEMS,
  ...TOUR_SHOWING_FAILURE_REASON_OPTION_ITEMS,
  ...TOUR_AGENT_SHOWING_FAILURE_REASON_OPTION_ITEMS,
];

export const TOUR_SHOWING_SOURCE_ADMIN_ADD_TO_TOUR = 'admin add to tour';
export const TOUR_SHOWING_SOURCE_AGENT = 'agent';

export const TOUR_SHOWING_RATING_POSITIVE = 'TOUR_SHOWING_RATING_POSITIVE';
export const TOUR_SHOWING_RATING_NEGATIVE = 'TOUR_SHOWING_RATING_NEGATIVE';
export const TOUR_SHOWING_RATING_NO_RESPONSE = 'TOUR_SHOWING_RATING_NO_RESPONSE';

export const TOUR_FEEDBACK_TAGS_LOW_RATING = [
  'Too Small', 'Dirty', ' Too Expensive', 'Bad Location',
  'Unkept Yard', 'Bad Layout', 'Little Natural Light',
];

export const TOUR_FEEDBACK_TAGS_HIGH_RATING = [
  'Great Size', 'Clean', 'Right Price', 'Fantastic Location',
  'Nice Layout', 'Great Yard', 'Lots Of Natural Light',
];
